import React from 'react';

import { CurrencyCodeType } from '@/types/currency';
import { isCurrencyCodeType } from '@/types/currency.ext';
import { TransactionResponse } from '@/types/transaction';

interface ProcessedAmounts {
  readonly fromAmount: number;
  readonly fromCurrency: CurrencyCodeType;
  readonly toAmount: number;
  readonly toCurrency: CurrencyCodeType;
}

export const useProcessedTxAmounts = (
  transaction: TransactionResponse | undefined,
): ProcessedAmounts => {
  return React.useMemo((): ProcessedAmounts => {
    if (transaction === undefined) {
      return {
        fromAmount: 0,
        fromCurrency: CurrencyCodeType.UNSET,
        toAmount: 0,
        toCurrency: CurrencyCodeType.UNSET,
      };
    }
    const { from, to } = transaction;

    return {
      fromAmount: isNaN(Number(from.value)) ? 0 : Number(from.value),
      fromCurrency:
        (isCurrencyCodeType(from.currencyCode) ? from.currencyCode : undefined) ??
        CurrencyCodeType.UNSET,
      toAmount: isNaN(Number(to.value)) ? 0 : Number(to.value),
      toCurrency:
        (isCurrencyCodeType(to.currencyCode) ? to.currencyCode : undefined) ??
        CurrencyCodeType.UNSET,
    };
  }, [transaction]);
};
